import * as React from 'react';

import { cn } from '@rematter/ui-web';

export interface LineItemRowProps {
  gridTemplate: string;
  children: React.ReactNode;
  className?: string;
}

export const LineItemRow: React.FC<LineItemRowProps> = ({
  gridTemplate,
  children,
  className,
}) => (
  <div className={cn('@LineItemRow grid gap-2', gridTemplate, className)}>
    {children}
  </div>
);
